import React, { useEffect, useState, useRef } from "react";
import "./AddSchemeForm.css";
import { Button } from "react-bootstrap";
import {
  get_scheme_type,
  add_schemes,
  getSchemeAccountBalances,
  get_schemes_flags,
  uploadFile,
  get_schemes_details_by_id,
  update_scheme_by_id
} from "../../../helper/Api";
import {
  ADD_SCHEME_START,
  ADD_SCHEME_FAIL,
} from "../../../RTK/Slices/SchemeSlice";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import AddIcon from "@mui/icons-material/Add";
import { toast } from "react-toastify";
import {
  UPLOAD_DOC_ACCEPT,
  validateUploadDocument,
} from "../../../helper/uploadValidation";
import { getApiErrorMessage } from "../../../helper/captcha";
import AddSchemePreview from "../../Modal/AddSchemePreview";
import { 
    FormControl, 
    InputLabel, 
    Select, 
    MenuItem,
    TextField,
    Box, IconButton, Typography
} from "@mui/material";
import PictureAsPdfIcon from '@mui/icons-material/PictureAsPdf';
import InsertDriveFileIcon from '@mui/icons-material/InsertDriveFile';
import CustomBreadcrumbs from "../../Tools/Breadcumbs";
import { isValidURL } from '../../../helper/Utils';
import SchemeBankModal from "./SchemeComponents/BankModal";
import Spinner from "../../Tools/spinner";

const AddSchemeForm = () => {
  const { financialYears } = useSelector((state) => state.authData);
  const fy_list = financialYears.payload.fy_list;
  const [st_list, set_st_list] = useState([]);
  const handleClose = () => setOpen(false);
  const [open, setOpen] = useState(false);
  const bankDetailsRef = useRef({});
  const [accountList, setAccountList] = useState([]);
  const [showPreview, setShowPreview] = useState(false);
  const dispatch = useDispatch();
  const { authData } = useSelector((state) => state.authData);
  const [files, setFiles] = useState([]);
  const navigate = useNavigate();
  const [schemeFlag, setSchemeFlag] = useState([]);
  const { id } = useParams();
  const [loading, setLoading] = useState(false);

  const [formData, setFormData] = useState({
    name: "",
    code: "", //required
    type: "", //required
    grant_code: "", //required
    department: "", //required
    financial_year: "", //required
    carry_forwarded: "", 
    is_activity_active: "", //required
    monitoring_level: "",
    account_id: "", //required
    change_reimbursement_payment_flow: "", // required
    reimbursement_payment_levels: [],
    added_by: authData && authData.status ? authData.user.id : null,
  });
  const fetch_list = async () => {
    setLoading(true);
    const st = await get_scheme_type();
    const accounts = await getSchemeAccountBalances({department_id: authData.user.department_details.id});
    if (st.data.status) {
      setLoading(false);
      set_st_list(st.data.list);
    }
    if (accounts.data.status) {
      setLoading(false);
      setAccountList(accounts.data.result);
    }
  };
  
  const fetchSchemeFlag = async () => {
    try {
      const resp = await get_schemes_flags();
      if (resp.data.status) {
        setSchemeFlag(resp.data.result);
      }
    } catch (error) {
      setSchemeFlag([]);
    }
  };

  const get_scheme_details = async (id) => {
        try {
          setLoading(true);
            const { data } = await get_schemes_details_by_id(id);
            if(data.schemes.length > 0) {
                setFormData({
                  name: data.schemes[0].name,
                  code: data.schemes[0].code,
                  type: data.schemes[0].type_id,
                  grant_code: data.schemes[0].grant_code,
                  department: data.schemes[0].department,
                  financial_year: data.schemes[0].financial_year_id,
                  carry_forwarded: data.schemes[0].carry_forwarded, 
                  is_activity_active: data.schemes[0].is_activity_active,
                  monitoring_level: data.schemes[0].monitoring_level,
                  account_id: data.schemes[0].account_id,
                  change_reimbursement_payment_flow: data.schemes[0].change_reimbursement_payment_flow,
                  reimbursement_payment_levels: data.schemes[0].reimbursement_payment_levels,
                })
                setFiles(data.schemes[0]?.documents || []);
                setLoading(false);
            }
        } catch (error) {
            setLoading(false);
            toast.error('Scheme not found', {
              position: toast.POSITION.TOP_CENTER,
            });
        }
    }

  useEffect(() => {
    fetchSchemeFlag();
    fetch_list();
    if(id) {
      get_scheme_details(id)
    }
  }, [id]);

  const handleSchemFormData = (e) => {
    const name = e.target.name;
    const value = e.target.value;
    if (name == "reimbursement_payment_levels") {
      let updatedLevels = [...formData.reimbursement_payment_levels];
      if (e.target.checked) {
        if (!updatedLevels.includes(value)) {
          updatedLevels.push(value);
        }
      } else {
        updatedLevels = updatedLevels.filter((level) => level !== value);
      }
      setFormData({
        ...formData,
        reimbursement_payment_levels: updatedLevels,
      });
    } else {
      if ((name === 'grant_code' || name === 'code') && !/^\d*$/.test(value)) {
        return;
      }
      if(name === 'grant_code' && value.length > 3) {
        return;
      }
      if(name === 'code' && value.length > 13) {
        return;
      }
      setFormData({ ...formData, [name]: value });
    }
  };

  const handleSubmit = async (e) => {
    e.preventDefault();

    try {
      let body = {
        ...formData, added_by: authData.user.id, files
      }
      dispatch(ADD_SCHEME_START());
      let add_scheme_response;
      if(id) {
        add_scheme_response = await update_scheme_by_id(body, id);
      } else {
        add_scheme_response = await add_schemes(body);
      }
      let addSchemeResponseData = add_scheme_response.data;
      if (addSchemeResponseData.status) {
        setShowPreview(false);
        toast.success(addSchemeResponseData.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        navigate("/add-subhead");
      } else {
        toast.error(addSchemeResponseData.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        dispatch(ADD_SCHEME_FAIL(addSchemeResponseData.message));
      }
    } catch (error) {
      dispatch(ADD_SCHEME_FAIL("error getting while add scheme"));
    }
  };

  const previewhandler = (e) => {
    e.preventDefault();
    
    // Validate required fields
    if (!formData.name || formData.name.trim() === "") {
      toast.error("Scheme Name is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (!formData.code || formData.code.trim() === "") {
      toast.error("Scheme Code is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (!/^\d{13}$/.test(String(formData.code).trim())) {
      toast.error("Scheme Code must be exactly 13 digits (numbers only)", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (!formData.type || formData.type === "") {
      toast.error("Scheme Type is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (!formData.grant_code || formData.grant_code.trim() === "") {
      toast.error("Grant Code is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }

    if (!/^\d{3}$/.test(String(formData.grant_code).trim())) {
      toast.error("Grant Code must be exactly 3 digits (numbers only)", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (!formData.department || formData.department.trim() === "") {
      toast.error("Department is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (!formData.financial_year || formData.financial_year === "") {
      toast.error("Financial Year is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (!formData.is_activity_active || formData.is_activity_active === "") {
      toast.error("Activity Status is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (!formData.account_id || formData.account_id === "") {
      toast.error("Account is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    if (authData.user.department_details.is_multi === "1" && (!formData.change_reimbursement_payment_flow || formData.change_reimbursement_payment_flow === "")) {
      toast.error("Reimbursement Payment Flow is required", {
        position: toast.POSITION.TOP_CENTER,
      });
      return;
    }
    
    // If all validations pass, show preview
    setShowPreview(true);
  };
  
  const linksArray = [
    {
        href: "/schemes",
        label: "Schemes",
    }
  ];

  const handleBankDetailModal = (bankDetails) => {
    bankDetailsRef.current = accountList.find(account => account.id === bankDetails);
    setOpen(true);
  }

  const handleFileChange = async (event) => {
    try {
      setLoading(true);
      const file = event.target.files[0];
      if (!file) {
        setLoading(false);
        return;
      }
      const validation = validateUploadDocument(file);
      if (!validation.ok) {
        toast.error(validation.message, {
          position: toast.POSITION.TOP_CENTER,
        });
        event.target.value = "";
        setLoading(false);
        return;
      }
      const formData = new FormData();
      formData.append("doc", file);
      formData.append("folderName", "scheme");
      const response = await uploadFile(formData);
      if(response.data.status) {
        setLoading(false);
        setFiles(prev => [...prev, { path: response.data.path || response.data.url, url: response.data.path || response.data.url }]);
      } else {
        setLoading(false);
        toast.error(response.data.message || response.data.error || 'File upload failed', {
          position: toast.POSITION.TOP_CENTER,
        });
        event.target.value = "";
      }
    }catch(error) {
      setLoading(false);
      event.target.value = "";
      toast.error(getApiErrorMessage(error, 'Something went wrong with file upload.'), {
          position: toast.POSITION.TOP_CENTER,
        });
    }
  };

  const handleRemove = (index) => {
    const newFiles = [...files];
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

  const renderFilePreview = (file, index) => {
    const url = file?.url || '';
    const fileExtension = url.split('.')?.pop()?.toLowerCase();
    const isImage = ['jpg', 'jpeg', 'png'].includes(fileExtension);
    const isDocument = fileExtension === 'pdf';
    const validUrl = isValidURL(url);
    
    // Sanitize URL to prevent DOMXSS
    const sanitizeUrl = (urlString) => {
      try {
        const urlObj = new URL(urlString);
        if (!['http:', 'https:'].includes(urlObj.protocol)) return '';
        return urlString;
      } catch (e) {
        return '';
      }
    };
    
    const safeUrl = sanitizeUrl(url);
    
    return (
      <Box key={index} sx={{ width: 150, textAlign: 'center', marginRight: 2 }}>
        {validUrl && safeUrl ? (
          isImage ? (
            <img src={safeUrl} alt="preview" style={{ width: 150, height: 150, objectFit: 'cover', borderRadius: 8 }} />
          ) : isDocument ? (
            <a href={safeUrl} download style={{ textDecoration: 'none', color: 'inherit' }} target="_blank" rel="noopener noreferrer">
              <Box sx={{ width: 150, height: 150, display: 'flex', justifyContent: 'center', alignItems: 'center', backgroundColor: '#f0f0f0', borderRadius: 8 }}>
                {fileExtension === 'pdf' ? <PictureAsPdfIcon fontSize="large" color="error" /> : <InsertDriveFileIcon fontSize="large" color="primary" />}
              </Box>
              <Typography variant="body2" noWrap>{url}</Typography>
            </a>
          ) : (
            <Typography variant="body2">Attachment</Typography>
          )
        ) : (
          <Typography variant="body2" color="textSecondary">Invalid file</Typography>
        )}
        <Button color="error" size="small" variant="contained" onClick={() => handleRemove(index)} sx={{ mt: 1 }} style={{    background: "#e71818",
    padding: "1px 10px",
    color: "#fff", marginTop: "5px"}} >
          Remove
        </Button>
      </Box>
    );
  };



  return (
    <div>
      {loading && <div > <Spinner/> </div>}
      <AddSchemePreview
        showPreview={showPreview}
        setShowPreview={setShowPreview}
        formData={formData}
        handleSubmit={handleSubmit}
        schemeTypes={st_list}
        financialYears={fy_list}
        schemeFlag={schemeFlag}
      ></AddSchemePreview>

      {/* --------------------olddesign============= */}

      <div className="p-3">
        <div className="row">
            <div className="col-md-6">
                <h4> Add Scheme</h4>
                <CustomBreadcrumbs linksArray={linksArray} title="Add Scheme"/>
            </div>
            <div className="col-md-6">
                <div className="d-flex gap-2" style={{ width: "auto", float: "right" }}>
                    
                    <button
                    type="submit"
                    className="submit_button"
                    onClick={previewhandler}
                    >
                    <span className="fs-14px">Save</span>
                    </button>
                    <button
                        type="button"
                        className="navigation_button"
                        onClick={() => navigate("/add-subhead")}
                    >
                        <span className="fs-14px">Add Subhead</span>
                    </button>
                </div>
            </div>
          <div className="col-md-12">
            <div className="p-0 m-0 px-2 mt-3 overflow-hidden bg-white">
              <div className="row">
                <div className="bg-prime-20 d-flex justify-content-between align-items-center p-2 transition overflow-hidden">
                  <span
                    className="fs-14px white-space-nowrap overflow-x-hidden"
                    style={{ width: "95%", fontStyle: "italic" }}
                  >
                    <span
                      className="fs-14px white-space-nowrap overflow-x-hidden "
                      style={{ width: "95%" }}
                    >
                      <span
                        className="fw-600 fs-16px"
                        style={{ fontStyle: "normal" }}
                      >
                        General
                      </span>
                    </span>
                  </span>
                </div>
                <div className="col-md-12">
                  <div className="row p-2">
                    {/* =====financial-year======= */}
                    <div className="col-sm-6 col-lg-4 p-2">
                        <FormControl fullWidth>
                            <InputLabel id="demo-simple-select-label">Financial Year *</InputLabel>
                            <Select
                                labelId="demo-simple-select-label"
                                id="demo-simple-select"
                                value={formData.financial_year || ""}
                                label="Financial Year *"
                                name="financial_year"
                                onChange={handleSchemFormData}
                            >
                                {fy_list.map((fy) => (
                                    <MenuItem value={fy.id} key={fy.id}>
                                        {fy.year}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>
                    <div className="col-sm-6 col-lg-4 p-2">
                        <FormControl fullWidth>
                            <TextField 
                            id="ndepartment_name"
                            label="Department Name" 
                            value={formData.department || ""}
                            variant="outlined" 
                            type="text"
                            name="department"
                            onChange={handleSchemFormData}
                            InputLabelProps={{ shrink: Boolean(id) || Boolean(formData.department) }}
                            required
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-6 col-lg-4 p-2">
                        <FormControl fullWidth>
                            <InputLabel id="scheme_type">Scheme Type *</InputLabel>
                            <Select
                                labelId="scheme_type"
                                id="scheme-type-select"
                                value={formData.type || ""}
                                label="Scheme Type "
                                name="type"
                                onChange={handleSchemFormData}
                                required
                            >
                                {st_list.map((st) => (
                                    <MenuItem value={st.id} key={st.id}>
                                        {st.title}
                                    </MenuItem>
                                ))}
                            </Select>
                        </FormControl>
                    </div>

                    <div className="col-sm-6 col-lg-4 p-2">
                        <FormControl fullWidth>
                            <TextField 
                            id="name"
                            label="Scheme Name"
                            value={formData.name || ""}
                            variant="outlined" 
                            type="text"
                            name="name"
                            onChange={handleSchemFormData}
                            InputLabelProps={{ shrink: Boolean(id) || Boolean(formData.name) }}
                            required
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-6 col-lg-4 p-2">
                        <FormControl fullWidth>
                            <TextField 
                            id="grant_code"
                            label="Grant Code" 
                            variant="outlined" 
                            type="number"
                            name="grant_code"
                            value={formData.grant_code || ""}
                            onChange={handleSchemFormData}
                            error={formData.grant_code && !/^\d{3}$/.test(String(formData.grant_code))}
                            helperText={formData.grant_code && !/^\d{3}$/.test(String(formData.grant_code)) ? "Grant Code must be exactly 3 digits (numbers only)" : ""}
                            required
                            />
                        </FormControl>
                    </div>
                    <div className="col-sm-6 col-lg-4 p-2">
                        <FormControl fullWidth>
                            <TextField 
                            id="scheme_code" 
                            label="Scheme Code" 
                            variant="outlined" 
                            type="number"
                            name="code"
                            value={formData.code || ""}
                            error={formData.code && !/^\d{13}$/.test(String(formData.code))}
                            helperText={formData.code && !/^\d{13}$/.test(String(formData.code)) ? "Scheme Code must be exactly 13 digits (numbers only)" : ""}
                            onChange={handleSchemFormData}
                            required
                            />
                        </FormControl>
                    </div>

                    <div className="col-sm-12 p-2">
                      <div className="row">
                        <div className="col-sm-6 col-lg-4 p-2">
                            <FormControl fullWidth>
                                <InputLabel id="bank_account_label">Bank Account *</InputLabel>
                                <Select
                                    labelId="bank_account_label"
                                    value={formData.account_id || ""}
                                    label="Bank Account *"
                                    name="account_id"
                                    onChange={handleSchemFormData}
                                    required
                                >
                                    {accountList.map((account) => (
                                        <MenuItem value={account.id} key={account.id}>
                                            {account.account_name} [A/c No: {account.account_no}]
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                        </div>

                        <div className="col-sm-6 col-lg-4 d-flex align-items-center">
                          <button
                            onClick={() => handleBankDetailModal(formData.account_id)}
                            type="button"
                            className="m-0 py-1 px-1 text-prime-100 fs-16px bg-white rounded-2 d-flex justify-content-center align-items-center gap-1"
                            style={{
                              border: "1px solid #2490EA",
                              width: "200px",
                            }}
                            disabled={!formData.account_id}
                          >
                            {" "}
                            <i className="icon-account_balance"></i>
                            View Bank Details
                          </button>
                        </div>
                        <div className="bg-prime-20 px-2 fs-16px fw-600 py-1">
                        Upload Scheme Documents
                        </div>
                        <Box sx={{ display: 'flex', gap: 2, flexWrap: 'wrap' }} style={{ marginTop: "10px" }}>
                            {files.map((file, index) => renderFilePreview(file, index))}
                        
                            <Box sx={{ width: 150, height: 150, borderRadius: 2, backgroundColor: '#e6f9fc', display: 'flex', alignItems: 'center', justifyContent: 'center', cursor: 'pointer' }}>
                                <input type="file" hidden id="file-upload" accept={UPLOAD_DOC_ACCEPT} onChange={handleFileChange} />
                                <label htmlFor="file-upload">
                                <IconButton component="span">
                                    <AddIcon fontSize="large" />
                                </IconButton>
                                </label>
                            </Box>
                            </Box>

                        {/* ================================budgeting================================= */}

                        <div className="bg-prime-20 px-2 fs-16px fw-600 py-1" style={{ marginTop: "10px" }}>
                          Budgeting
                        </div>

                        <div className="col-6 p-2">
                          <div className="form-group d-flex gap-1">
                            <FormControl fullWidth>
                                <InputLabel id="activity_wise">Activity wise Budgeting *</InputLabel>
                                <Select
                                    labelId="activity_wise"
                                    value={formData.is_activity_active || ""}
                                    label="Activity wise Budgeting *"
                                    name="is_activity_active"
                                    onChange={handleSchemFormData}
                                    required
                                >
                                    <MenuItem value="">---Select---</MenuItem>
                                    <MenuItem value="1">YES</MenuItem>
                                    <MenuItem value="0">NO</MenuItem>
                                </Select>
                            </FormControl>
                          </div>
                        </div>

                        {formData.is_activity_active == "1" && (
                          <div className="col-6 p-2">
                            <div className="form-group d-flex gap-1">
                            <FormControl fullWidth>
                                <InputLabel id="monitoring_level">Monitor/Control Level *</InputLabel>
                                <Select
                                    labelId="monitoring_level"
                                    value={formData.monitoring_level || ""}
                                    label="Monitor/Control Level *"
                                    name="monitoring_level"
                                    onChange={handleSchemFormData}
                                    required
                                >
                                    <MenuItem value="">---Select---</MenuItem>
                                    {schemeFlag.map((option) => (
                                        <MenuItem key={option.id} value={option.id}>
                                            {option.name}
                                        </MenuItem>
                                    ))}
                                </Select>
                            </FormControl>
                            </div>
                          </div>
                        )}

                        {/* ===========================bdt i nach======================================= */}
                        { authData.user.department_details.is_multi === "1" &&
                          <div className="bg-prime-20 px-2 fs-16px fw-600 py-1">
                            DBT I NACH
                          </div>
                        }
                      </div>
                    </div>

                    {/* ======================================subheads=============================== */}
                    {
                      authData.user.department_details.is_multi === "1" &&
                      <div className="col-6 p-2">
                        <div className="form-group d-flex gap-1">
                          <FormControl fullWidth>
                              <InputLabel id="payment_flow">Change Payment Flow *</InputLabel>
                              <Select
                                  labelId="payment_flow"
                                  value={formData.change_reimbursement_payment_flow || ""}
                                  label="Change Payment Flow *"
                                  name="change_reimbursement_payment_flow"
                                  onChange={handleSchemFormData}
                                  required
                              >
                                  <MenuItem value="">---Select---</MenuItem>
                                  <MenuItem value="1">YES</MenuItem>
                                  <MenuItem value="0">NO</MenuItem>
                              </Select>
                          </FormControl>
                        </div>
                      </div>
                    }
                    

                    {formData.change_reimbursement_payment_flow == "1" && (
                      <div className="col-sm-8 p-2">
                        <div className="form-group d-flex gap-1">
                          <label htmlFor="inputType" className="">
                            <span className="fs-16px">Payment Levels * :</span>
                          </label>
                          <div className="col-sm-8">
                            <div className="form-check form-check-inline">
                              <input
                                type="checkbox"
                                id="T1"
                                name="reimbursement_payment_levels"
                                value="T1"
                                checked={formData.reimbursement_payment_levels.includes(
                                  "T1"
                                )}
                                onChange={handleSchemFormData}
                                className="form-check-input"
                              />
                              <label className="form-check-label" htmlFor="T1">
                                T1
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="checkbox"
                                id="T2"
                                name="reimbursement_payment_levels"
                                value="T2"
                                checked={formData.reimbursement_payment_levels.includes(
                                  "T2"
                                )}
                                onChange={handleSchemFormData}
                                className="form-check-input"
                              />
                              <label className="form-check-label" htmlFor="T2">
                                T2
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="checkbox"
                                id="T3"
                                name="reimbursement_payment_levels"
                                value="T3"
                                checked={formData.reimbursement_payment_levels.includes(
                                  "T3"
                                )}
                                onChange={handleSchemFormData}
                                className="form-check-input"
                              />
                              <label className="form-check-label" htmlFor="T3">
                                T3
                              </label>
                            </div>
                            <div className="form-check form-check-inline">
                              <input
                                type="checkbox"
                                id="T4"
                                name="reimbursement_payment_levels"
                                value="T4"
                                checked={formData.reimbursement_payment_levels.includes(
                                  "T4"
                                )}
                                onChange={handleSchemFormData}
                                className="form-check-input"
                              />
                              <label className="form-check-label" htmlFor="T4">
                                T4
                              </label>
                            </div>
                          </div>
                        </div>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>
          {/* </Form> */}
        </div>
      </div>

      <SchemeBankModal 
        open={open} 
        handleClose={handleClose}
        bankDetails={bankDetailsRef.current}
      />
    </div>
  );
};

export default AddSchemeForm;
